export const API_BASE_URL = import.meta.env.VITE_BASE_API_ENDPOINT;
export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL;
